import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Reviews } from './common/Reviews/Reviews'
import { Edit3Icon } from 'components/shared/Icon/model'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { Icon } from 'components/shared/Icon/Icon'
import {
  InterviewStateContext,
  InterviewHandlersContext,
} from 'components/modules/interview/context'
import { getFactorScoreTreshholds } from 'utils/score'
import { useContext } from 'hooks'

import styles from './Report.module.scss'

export const Report = () => {
  const state = useContext(InterviewStateContext)
  const { toggleEditMode } = useContext(InterviewHandlersContext)

  const {
    evaluators,
    interviewAverageScore,
    candidate: { name },
    interviewSummary: { skills },
  } = state

  return (
    <Box direction="column" className={styles.report}>
      <Box className={styles.header}>
        <Box>
          <h2 className={styles.titleSection}>
            <span className={styles.name}>{name}</span>
            <span className={styles.title}>{t`Interview report`}</span>
          </h2>
          <button className={styles.icon} onClick={() => toggleEditMode()}>
            <Icon icon={Edit3Icon} size={24} />
          </button>
        </Box>
        <Box className={styles.overallScore}>
          <span className={styles.scoreLabel}>{t`OVERALL SCORE`}</span>
          <ScoreChip
            score={interviewAverageScore}
            size="large"
            theme={getFactorScoreTreshholds(interviewAverageScore)}
          />
        </Box>
      </Box>
      <Reviews {...{ evaluators, skills }} />
    </Box>
  )
}
